import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';

const Spinner = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
    <CircularProgress size={32} />
  </Box>
);

/**
 * Laat een route alleen zien als de gebruiker volledig is aangemeld (inclusief 2FA).
 *
 * De 2FA-status komt uit AuthContext (`authLevel`); deze component doet zelf geen
 * Supabase-aanroepen en houdt geen eigen cache bij. Daardoor zien navbar, Login en
 * beschermde routes altijd dezelfde status (geen redirect-lus na 2FA-verificatie).
 */
const RequireAuth = ({ children }) => {
  const { user, loading, authLevel } = useContext(AuthContext);
  const location = useLocation();

  if (loading || (user && authLevel === 'checking')) return <Spinner />;

  if (!user || authLevel !== 'full') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
